import { render, staticRenderFns } from "./text-with-cmp.vue?vue&type=template&id=5756149e&scoped=true"
import script from "./text-with-cmp.vue?vue&type=script&lang=js"
export * from "./text-with-cmp.vue?vue&type=script&lang=js"
import style0 from "./text-with-cmp.vue?vue&type=style&index=0&id=5756149e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5756149e",
  null
  
)

export default component.exports